<script setup lang="ts">
import { computed } from "vue";
import { useRolesStore } from "@/stores/roles";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";
import AddRole from "@/components/AddRole.vue";
import CsRoleList from "@/components/CsRoleList.vue";

const roles = useRolesStore();
const auth = useAuthStore();

const { loading } = storeToRefs(roles);
const { role } = storeToRefs(auth);
const canEdit = computed(() => {
  return ["dev", "csadm"].includes(role.value);
});
</script>

<template>
  <CsRoleList />

  <section v-show="!loading && canEdit">
    <AddRole :cs="true" />
  </section>
</template>
<style lang="scss" scoped>
.isDisabled > td {
  text-decoration: line-through;
  background: #ddd !important;
}
</style>
